import { FILENAME_RESTRICTED_SYMBOLS_REGEX } from './filename-restricted-symbols-regex';

export function filenameFromString(
  source: string,
  separator = ' ',
  restrictedCharsRegexp = FILENAME_RESTRICTED_SYMBOLS_REGEX,
) {
  return source.replace(restrictedCharsRegexp, separator);
}
